import React from 'react';
import { Modal, Checkbox, Spin, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

let type = "INV_SIMPLE_LIST";

class ConfigColumn extends React.Component {
    state = {
        params: {},
        columns: [],
        visible: false,
        selectAll: false,
    }

    show = () => {
        this.setState({
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    loadData = () => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.common.queryUserDisplayDefineByType,
            data: { type },
            dataType: 'json',
            doneResult: res => {
                const columns = res[type] || [];
                const selectAll = columns.every(column => column.isShow == 1);
                this.setState({
                    columns,
                    selectAll,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    handleSubmit = () => {
        const { columns } = this.state;
        this.setState({ loading: true });
        
        const params = {};
        columns.forEach((column, index) => {
            const { isShow, userCustomDisplayDefineId, displayType } = column;
            params[`customDisplayDefines[${index}].userCustomDisplayDefineId`] = userCustomDisplayDefineId;
            params[`customDisplayDefines[${index}].isShow`] = isShow;
            params[`customDisplayDefines[${index}].displayType`] = displayType;
        });

        const options = {
            method: 'POST',
            url: API_URL.common.setUserDisplayDefineValue,
            data: {
                ...params,
                type
            },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        }
        $.sendRequest(options)
    }

    onCheckChange = (e, index) => {
        const { columns } = this.state;
        columns[index].isShow = e.target.checked ? 1 : 0;
        this.setState({ columns });
    }

    handleSelectAll = (e) => {
        const { columns } = this.state;
        const selectAll = e.target.checked;
        columns.forEach(column => {
            if (column.isDefault != 1) {
                column.isShow = selectAll ? 1 : 0;
            }
        });
        this.setState({ columns, selectAll });
    }

    render() {
        const { visible, loading, columns, selectAll } = this.state;
        return (
            <Modal
                title="自定义显示列"
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="condition-modal"
                maskClosable={false}
                width="800px"
                confirmLoading={loading}
            >
                <Spin spinning={loading}>
                    <div>
                        <Checkbox checked={selectAll} onChange={this.handleSelectAll}>全选</Checkbox>
                        <div className="configColumn">
                            {
                                columns.map((item, index) => {
                                    const { isShow, title, dataIndex, isDefault } = item;
                                    return (
                                        <div key={dataIndex} className="configColumn_item">
                                            <Checkbox
                                                disabled={isDefault == 1}
                                                checked={isShow == 1}
                                                onChange={(e) => this.onCheckChange(e, index)}
                                            >
                                                <span title={title} className="configColumn_text" style={{ width: 160 }}>{title}</span>
                                            </Checkbox>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default ConfigColumn;



// WEBPACK FOOTER //
// ./src/components/investigation/Simple/ConfigColumn.js